import React, { useState } from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { DefaultView, OptionalEditView, Views } from '../../../types/BlockWithViews';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { LatestForumPostsDefaultView } from '../views/LatestForumPostsDefaultView';
import { LatestForumPostsEditView } from '../views/LatestForumPostsEditView';
import { BlockBar, BlockBarAnchor, useBlockBarCreateHref } from '../../../_lib/components/BlockBar';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useAppContext } from '../../../contexts/AppContext/AppContext';

export type LatestForumPostsBlockProps = Views<
  DefaultView<LatestForumPostsDefaultView> & OptionalEditView<LatestForumPostsEditView>
>;

export function LatestForumPostsInteractions({ views, activeView }: LatestForumPostsBlockProps) {
  const { t } = useSonTranslation('LatestForumPosts');
  const { editModeInfo } = useAppContext();
  const id = useHtmlValidId();
  const { refresh } = useRefreshBlock();
  const [currentActiveView, setCurrentActiveView] = useState(activeView);
  const currentActiveViewHref = useBlockBarCreateHref(
    currentActiveView,
    { default: views.edit?.href, edit: views.default?.href },
    id,
  );

  const getActiveView = () => {
    if (currentActiveView === 'default') {
      return <LatestForumPostsDefaultView {...views.default} />;
    }

    if (currentActiveView === 'edit') {
      return <LatestForumPostsEditView {...(views.edit as LatestForumPostsEditView)} />;
    }

    return null;
  };

  return (
    <>
      {editModeInfo.active && views.edit
        ? <BlockBar heading={t('edit.titleText')} hierarchy={3}>
            <BlockBarAnchor
              href={currentActiveViewHref}
              onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                event.stopPropagation();
                event.preventDefault();

                if (currentActiveView === 'default') {
                  setCurrentActiveView('edit');
                } else if (currentActiveView === 'edit') {
                  setCurrentActiveView('default');
                  refresh();
                }
              }}
              text={t('edit.text')}
              svgSpriteId={currentActiveView === 'edit' ? Icons.DECLINE_CROSS : Icons.EDIT_PENCIL}
              aria-controls={id}
              aria-expanded={currentActiveView === 'edit'}
            />
          </BlockBar>
        : null}
      <div id={id}>{getActiveView()}</div>
    </>
  );
}
